import { useContext } from 'react';
import { useIsSmallScreen } from '../../../../../../Hooks/useFullscreenView';
import {
  IFunctionMenuItem,
  useBusinessCollectionMenuItemsType,
} from '../../../../../../Utils/ObjektVyUtils';
import { ViewDbSettingsContext } from '../Components/SchedulerComponent/ViewDbSettingsContext';
import {
  AvenySYSOptionQuery,
  AvenySYSOptionQueryVariables,
} from '../../../../../../Components/QueryComponents/AvenySYSOptionQuery/_QueryTypes/AvenySYSOptionQuery';
import { useQuery } from '@apollo/client';
import { ActiveDatabaseContext } from '../../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import optionQuery from '../../../../../../Components/QueryComponents/AvenySYSOptionQuery/AvenySYSOptionQuery.gql';

export const useKalenderBusinessCollectionMenuItems: useBusinessCollectionMenuItemsType =
  () => {
    const activeDatabaseContext = useContext(ActiveDatabaseContext);
    const viewDbSettingsContext = useContext(ViewDbSettingsContext);
    const isSmallScreen = useIsSmallScreen();
    viewDbSettingsContext.setSeeMoreFeatures(true);
    const { currentView, showOutlookBookings } = viewDbSettingsContext || {};

    const viewToMenuIdMap: Record<string, string> = {
      Day: 'dayView',
      Day2: 'day2',
      Week: 'weekView',
      Week2: 'week2',
      Month: 'monthView',
      Month2: 'month2',
      WorkWeek: 'workweek',
      DayOverview: 'overViewDay',
      WeekOverview: 'overViewWeek1',
      WeekOverview2: 'overViewWeek2',
      List: 'list',
    };

    const isSelectedView = (itemId: string): boolean => {
      if (itemId === 'outlook') {
        return showOutlookBookings;
      }
      return currentView ? viewToMenuIdMap[currentView] === itemId : false;
    };

    const { data: sysoption_data } = useQuery<
      AvenySYSOptionQuery,
      AvenySYSOptionQueryVariables
    >(optionQuery, {
      fetchPolicy: 'cache-only',
      variables: {
        dbName: activeDatabaseContext.activeDatabase ?? '',
        subSystemCode: 'BO',
        optionKey: 'BO_NA_NEW_VIEWS',
      },
      skip: !activeDatabaseContext.activeDatabase,
    });

    const newViews = sysoption_data?.db?.SYSOptions_All?.[0]?.OptionData
      ? sysoption_data?.db?.SYSOptions_All?.[0]?.OptionData.split(',')
      : [];

    const hasNewViews = newViews.length > 0;

    if (isSmallScreen) {
      return [
        ...(!hasNewViews ||
        (hasNewViews && viewDbSettingsContext.currentView === 'Day')
          ? [
              {
                id: 'overview',
                caption: 'Översikt',
                iconType: 'people',
                onClick: () => {
                  viewDbSettingsContext.setOverView(oldValue => !oldValue);
                },
              } as IFunctionMenuItem,
            ]
          : []),
        {
          id: 'outlook',
          caption: 'Outlook',
          iconType: 'outlook',
          selected: isSelectedView('outlook'),
          onClick: () => {
            viewDbSettingsContext.setShowOutlookBookings(oldValue => !oldValue);
          },
        },

        ...(newViews.find(viewName => viewName === 'Day')
          ? [
              {
                id: 'dagView',
                caption: 'Dag',
                iconType: 'day',
                selected: isSelectedView('dagView'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Day');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'dayView',
                caption: 'Dag',
                iconType: 'day',
                selected: isSelectedView('dayView'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Day');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'Day2')
          ? [
              {
                id: 'day2',
                caption: 'Dag',
                iconType: 'day',
                selected: isSelectedView('day2'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Day2');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'day2',
                caption: 'Dag',
                iconType: 'day',
                selected: isSelectedView('day2'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Day2');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'Week')
          ? [
              {
                id: 'weekView',
                caption: 'Vecka',
                iconType: 'week',
                selected: isSelectedView('weekView'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Week');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'weekView',
                caption: 'Vecka',
                iconType: 'week',
                selected: isSelectedView('weekView'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Week');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'Week2')
          ? [
              {
                id: 'week2',
                caption: 'Vecka',
                iconType: 'week',
                selected: isSelectedView('week2'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Week2');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'week2',
                caption: 'Vecka',
                iconType: 'week',
                selected: isSelectedView('week2'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Week2');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'Month')
          ? [
              {
                id: 'monthView',
                caption: 'Månad',
                iconType: 'month',
                selected: isSelectedView('monthView'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Month');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'monthView',
                caption: 'Månad',
                iconType: 'month',
                selected: isSelectedView('monthView'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Month');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'Month2')
          ? [
              {
                id: 'month2',
                caption: 'Månad',
                iconType: 'month',
                selected: isSelectedView('month2'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Month2');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'month2',
                caption: 'Månad',
                iconType: 'month',
                selected: isSelectedView('month2'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('Month2');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'WorkWeek')
          ? [
              {
                id: 'workweek',
                caption: 'Arbetsvecka',
                iconType: 'week',
                selected: isSelectedView('workweek'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('WorkWeek');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'workweek',
                caption: 'Arbetsvecka',
                iconType: 'week',
                selected: isSelectedView('workweek'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('WorkWeek');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'DayOverview')
          ? [
              {
                id: 'overViewDay',
                caption: 'Översikt dag',
                iconType: 'overview',
                selected: isSelectedView('overViewDay'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('DayOverview');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'overViewDay',
                caption: 'Översikt dag',
                iconType: 'overview',
                selected: isSelectedView('overViewDay'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('DayOverview');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'WeekOverview')
          ? [
              {
                id: 'overViewWeek1',
                caption: 'Översikt vecka 1',
                iconType: 'overview',
                selected: isSelectedView('overViewWeek1'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('WeekOverview');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'overViewWeek1',
                caption: 'Översikt vecka 1',
                iconType: 'overview',
                selected: isSelectedView('overViewWeek1'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('WeekOverview');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'WeekOverview2')
          ? [
              {
                id: 'overViewWeek2',
                caption: 'Översikt vecka 2',
                iconType: 'overview',
                selected: isSelectedView('overViewWeek2'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('WeekOverview2');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'overViewWeek2',
                caption: 'Översikt vecka 2',
                iconType: 'overview',
                selected: isSelectedView('overViewWeek2'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('WeekOverview2');
                },
              } as IFunctionMenuItem,
            ]
          : []),

        ...(newViews.find(viewName => viewName === 'List')
          ? [
              {
                id: 'list',
                caption: 'Lista',
                iconType: 'list',
                selected: isSelectedView('list'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('List');
                },
              } as IFunctionMenuItem,
            ]
          : []),
        ...(newViews.find(viewName => viewName === 'All')
          ? [
              {
                id: 'list',
                caption: 'Lista',
                iconType: 'list',
                selected: isSelectedView('list'),
                onClick: () => {
                  viewDbSettingsContext.setCurrentView('List');
                },
              } as IFunctionMenuItem,
            ]
          : []),
      ];
    } else {
      return [];
    }
  };
